import linkedin from '../assent//linkedin (1).png';
import github from '../assent/github.png';
import facebook from '../assent/facebook.png';
import behance from '../assent/behance.png';


function Footer(){
    return(
        <>
        
        
{/* <!--footer--> */}
<footer class="footer">




<p class="copyright"> Code it's Fun | All Right Reserved </p>
</footer>

{/* <!--footer--> */}

        
        </>
    )
}
export default Footer